import {
  PASSWORD_POLICY_FETCH_REQUEST,
  PASSWORD_POLICY_FETCH_REQUEST_SUCCESS,
  PASSWORD_POLICY_FETCH_REQUEST_FAILURE,
  PASSWORD_POLICY_UPDATE_REQUEST,
  PASSWORD_POLICY_UPDATE_REQUEST_SUCCESS,
  PASSWORD_POLICY_UPDATE_REQUEST_FAILURE,
  PASSWORD_POLICY_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const passwordPoliciesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case PASSWORD_POLICY_FETCH_REQUEST:
    case PASSWORD_POLICY_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case PASSWORD_POLICY_FETCH_REQUEST_SUCCESS:
    case PASSWORD_POLICY_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case PASSWORD_POLICY_FETCH_REQUEST_FAILURE:
    case PASSWORD_POLICY_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case PASSWORD_POLICY_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default passwordPoliciesReducer;
